import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tiers',
  templateUrl: './tiers.component.html',
  styleUrls: ['./tiers.component.css']
})
export class TiersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
